import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useTranslation } from 'react-i18next';

export type ProfileForm = {
  nickname: string;
  job: string;
  summary: string;
  content: string;
};

const defaultValues: ProfileForm = {
  nickname: '',
  job: '',
  summary: '',
  content: '',
};

const useProfileForm = () => {
  const { t } = useTranslation();
  const Schema = Yup.object().shape({
    nickname: Yup.string()
      .optional()
      .transform((value) => value.trim())
      .matches(/^[a-z]*$/, t('MYPAGE.영어 소문자만 사용할 수 있어요.'))
      .max(15, t('MYPAGE.최대 {{n}}자까지 가능합니다.', { n: 15 })),
    job: Yup.string().optional(),
    summary: Yup.string()
      .optional()
      .transform((value) => value.trim())
      .max(40, t('MYPAGE.최대 {{n}}자까지 가능합니다.', { n: 40 })),
    content: Yup.string()
      .optional()
      .transform((value) => value.trim())
      .max(300, t('MYPAGE.최대 {{n}}자까지 가능합니다.', { n: 300 })),
  });

  return useForm<ProfileForm>({
    resolver: yupResolver(Schema),
    defaultValues,
    mode: 'onChange',
  });
};

export default useProfileForm;
